import axios from 'axios';
import store from '@/store/index'
//import app from '@/main'

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "accept": "*/*",
        "Content-Type": "application/json",
    }
});
///console.log(store.getters.token);
//if (store.getters.isLoggedIn) {
   // httpClient.defaults.headers.common['Authorization'] = store.getters.token
//}

httpClient.interceptors.request.use(config => {
    store.commit("on");   
    //this.$Progress.start()
    return config
})

httpClient.interceptors.response.use(response => {
    store.commit("off");
    //this.$Progress.finish()
        return response
    },
    error => {
        store.commit("off");
        //app.$Progress.finish();
        //console.log(this.$store.state.loading)
        //console.log(1232123)
        console.log(error)
        if (error.response.status === 401) {
            console.log(error.response.status)
            store.dispatch('logout');
        }
        return Promise.reject(error);
    });
export default httpClient;